export const buildHotmartUrl = (
  baseUrl: string,
  orderBumpChecked: boolean = false,
): string => {
  try {
    const urlParams = new URLSearchParams(window.location.search)
    const hotmartParams = new URLSearchParams()

    // 1. Captura de UTMs individuales
    const utms = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
    ]
    utms.forEach((utm) => {
      if (urlParams.get(utm)) hotmartParams.set(utm, urlParams.get(utm)!)
    })

    // 2. Lógica SRC/SCK Combinada (Atribución visual en Hotmart)
    const srcValue = utms.map((utm) => urlParams.get(utm) || 'none').join('|')

    hotmartParams.set('src', srcValue)
    hotmartParams.set('sck', srcValue)

    // 3. Soporte CAPI (fbp y fbc) - CRÍTICO para Hotmart API
    const getCookie = (name: string) => {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) return parts.pop()?.split(';').shift()
      return null
    }

    const fbp = getCookie('_fbp')
    const fbc = getCookie('_fbc') || urlParams.get('fbclid')

    if (fbp) hotmartParams.set('fbp', fbp)
    if (fbc) hotmartParams.set('fbc', fbc)

    // 4. Fallback para tráfico orgánico
    if (!urlParams.get('utm_source')) {
      hotmartParams.set('src', 'organico_lp')
    }

    // Unimos los parámetros a la URL base de Hotmart
    const separator = baseUrl.includes('?') ? '&' : '?'
    return `${baseUrl}${separator}${hotmartParams.toString()}`
  } catch (error) {
    console.error('Tracking Error:', error)
    return baseUrl
  }
}
